import { c as _c } from "react/compiler-runtime";
import React, { useContext } from "react";
import { WidgetTooltipContext } from "../../Widget";
import { ToolTipIcon } from "./ToolTipIcon";
import styles from "./ToolTip.module.scss";
export const ToolTip: React.FC<{
  text: string;
  linkUrl?: string;
}> = t0 => {
  const $ = _c(9);
  const {
    text,
    linkUrl
  } = t0;
  const [, setTooltip] = useContext(WidgetTooltipContext);
  let t1;
  if ($[0] !== linkUrl || $[1] !== setTooltip || $[2] !== text) {
    t1 = state => state ? setTooltip({
      text,
      link: linkUrl
    }) : setTooltip(null);
    $[0] = linkUrl;
    $[1] = setTooltip;
    $[2] = text;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== linkUrl) {
    t2 = () => linkUrl && window.open(linkUrl, "_blank");
    $[4] = linkUrl;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== t1 || $[7] !== t2) {
    t3 = <div className={styles.wrapper}><ToolTipIcon toggleTooltip={t1} onClick={t2} /></div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};